// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__jMdMK","Label":"Input_Label__2ziCO","InputElement":"Input_InputElement__1xh7D","Invalid":"Input_Invalid__2IfHW"};